import React from "react"
import { Link } from "gatsby"

// Components
import Layout from "../../../components/layout"
import FlowSummaryAnimation from "../../../components/flow-summary-animation"
import Band, { BandColors } from "../../../components/band"
import SEO from "../../../components/seo"
import FlowDataTableTopsNav from "../../../components/top-nav/flow-top-nav"

// CSS
import styles from "./flow-data-table.module.css"
import shared from "../../../shared/shared.module.css"
import grid from "../../../shared/bootstrap-grid.module.css"

// SVG
import FlowDataTablePromo from "../../../svg/FlowDataTable/FlowDataTablePromo.svg"
import FlowDataTable from "../../../svg/FlowDataTable/FlowDataTable.svg"
import AllObjectsPromo from "../../../svg/FlowDataTable/AllObjectsPromo.svg"

// Icons
import ClipboardIcon from "../../../icons/clipboard.svg"
import GearsIcon from "../../../icons/gears.svg"
import PdfIcon from "../../../icons/pdf.svg"

// Files
import ProductBriefPdfSrc from "../../../files/Flow Data Table Product Brief.pdf"

const FlowDataTableSummaryPage = () => (
  <Layout>
    <SEO title="Flow Data Table" keywords={[`tigerface`, `systems`, `salesforce`, `products`, `flow data table`]} />

    <FlowDataTableTopsNav />

    <Band>
      <section className={styles.productPromoTop}>
        <h1 className={styles.productPromoTitle}>Flow Data Table</h1>
        <p className={styles.productPromoSubTitle}>
          Flow Builder just got even more powerful!
        </p>

        {/* The animation. Will fallback to a static image */}
        <div className={styles.promoAnimationContainer}>
          <FlowDataTablePromo className={`${styles.productPromoImage} ${shared.w100}`} />
          <FlowSummaryAnimation className={styles.productPromoAnimation} />
        </div>

        <p className={styles.productPromoImageDesc}>
          Flow Data Table is a new Data Table screen component for Flow Builder.
        </p>
      </section>
    </Band>

    <Band color={BandColors.gray}>
      <div className={`${grid.row} ${grid.justifyContentBetween} ${grid.alignItemsCenter}`}>
        <div className={`${grid.colLg6}`}>
          <h2>Beautifully Display Records Within A Flow</h2>
          <p>
            Drag and drop <Link to="/products/flow-data-table/user-guides/getting-started" className={shared.tigerfaceLink}>a flow data table </Link>
            to your screen to display a list of records in table format.
          </p>
        </div>
        <div className={`${grid.colLg5} ${shared.hiddenMobile}`}>
          <FlowDataTable className={shared.w100} />
        </div>
      </div>
    </Band>

    <Band>
      <div className={`${grid.row} ${grid.justifyContentBetween} ${grid.alignItemsCenter}`}>
        <div className={`${grid.colLg4}  ${shared.hiddenMobile}`}>
          <AllObjectsPromo className={shared.w100} />
        </div>
        <div className={`${grid.colLg7}`}>
          <h2>Most standard and all custom objects are supported.</h2>
          <p>
            A table can be <Link to="/products/flow-data-table/user-guides/getting-started" className={shared.tigerfaceLink}>used </Link>
            to display most standard and all custom objects.
          </p>
        </div>
      </div>
    </Band>

    <Band color={BandColors.orange}>
      <h2 className={`${shared.textCenter} ${grid.mbLg5}`}>Learn More About Flow Data Table</h2>
      <div className={`${grid.row} ${grid.justifyContentCenter} ${grid.mxLgN5}`}>
        <div className={`${grid.col8} ${grid.colLg4} ${grid.pxLg5}`}>
          <Link to="/products/flow-data-table/features" className={`${shared.btn} ${shared.btnLight} ${styles.bigBtn}`}>
            <div className={styles.bigBtnIcon}>
              <ClipboardIcon />
            </div>
            <div className={styles.bigBtnText}>
              View The Full Feature Set
            </div>
          </Link>
        </div>
        <div className={`${grid.col8} ${grid.colLg4} ${grid.pxLg5} ${grid.mtLg0} ${grid.mt4}`}>
          <Link to="/products/flow-data-table/setup" className={`${shared.btn} ${shared.btnLight} ${styles.bigBtn}`}>
            <div className={styles.bigBtnIcon}>
              <GearsIcon />
            </div>
            <div className={styles.bigBtnText}>
              View The User Guide
            </div>
          </Link>
        </div>
        <div className={`${grid.col8} ${grid.colLg4} ${grid.pxLg5} ${grid.mtLg0} ${grid.mt4}`}>
          <a href={ProductBriefPdfSrc} className={`${shared.btn} ${shared.btnLight} ${styles.bigBtn}`} target="_blank" rel="noopener noreferrer">
            <div className={styles.bigBtnIcon}>
              <PdfIcon />
            </div>
            <div className={styles.bigBtnText}>
              View The Product Brief
            </div>
          </a>
        </div>
      </div>
    </Band>
  </Layout>
);

export default FlowDataTableSummaryPage;